import { render, staticRenderFns } from "./AccountPassword.vue?vue&type=template&id=058474af&"
import script from "./AccountPassword.vue?vue&type=script&lang=js&"
export * from "./AccountPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports